import DHSplashScreen from "../../component/DHSplashScreen";
import Footer from "../../component/Footer";
import Header from "../../component/Header";
import otp_icon from "../../images/otp_icon.svg";
import DH_Logo from "../../images/dh-logo-min-1.svg";
import { useNavigate } from "react-router-dom";
import {
  DECCAN_MOBILE_TAB,
  REDIRECT_URL,
  SELECTED_TAB_SEARCH_QUERY_PARAM_NAME,
  email_tab_indetifier,
  mobile_tab_indetifier,
} from "../../contant";
import DeccanOtpForm from "../../component/DeccanOTPForm";

export default function DeccanOTPPage({
  reference,
  OTP,
  setOTP,
  otpError,
  setOtpError,
  isDisableVerifyBtn,
  setIsDisableVeifyBtn,
  isDisableResendBtn,
  setIsDisableResendBtn,
  tabDetail,
  handleOTPInput,
  resendOTP,
  progress,
  pathname,
  fieldTobeUpdateData,
  setUserOTP,
  userOTP,
  userOtpError,
  setIsDisableUserVerifyBtn,
  isDisableUserVerifyBtn,
  emailRequired,
  signupMessage,
  isEmailUpdateOrPhoneNumber,
  setUserOtpError
}) {
  const navigate = useNavigate();
  const userLoginDetail =
    JSON.parse(window.localStorage.getItem("user_login_detail")) || {};
  return (
    <div className="lg:h-full xxxl:h-screen xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center lg:pt-8 px-10 md:p-0 md:pt-2 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen logoImage={DH_Logo} />
        <div className="w-1/2 shadow-md bg-white ml-2 rounded-2xl sm:w-full sm:ml-0 sm:flex sm:flex-col">
          <Header headerImage={otp_icon} />
          <p className="w-full text-gray-700 font-semibold mt-[72px] text-2xl leading-6">
            Verification
          </p>
          {pathname.includes("post_change_email") ? (
            <p className="text-gray-700 font-normal text-base mt-4 mb-28 leading-6 px-28 sm:px-2.5 md:px-3 lg:px-3">
              Verify using OTP sent via Email to {" "}<span className="text-gray-700 font-bold">{fieldTobeUpdateData}</span>{" "}
              <span
                className="text-[#0087C1] cursor-pointer font-semibold"
                onClick={() => navigate(`/auth/change_email`)}
              >
                Change
              </span>
            </p>
          ) : pathname.includes("post_change_phonenumber") ? (
            <p className="text-gray-700 font-normal text-base mt-4 mb-28 leading-6 px-28 sm:px-2.5 md:px-3 lg:px-3">
              Verify using OTP sent via SMS to {" "}<span className="text-gray-700 font-bold">{`+91 ${fieldTobeUpdateData}`}</span>{" "}
              <span
                className="text-[#0087C1] cursor-pointer font-semibold"
                onClick={() => navigate(`/auth/change_phonenumber`)}
              >
                Change
              </span>
            </p>
          ) : (
            <p className="text-gray-700 font-normal text-base mt-4 mb-28 leading-6 px-28 sm:px-2.5 md:px-3 lg:px-3">
              Verify using OTP sent via{" "}
              {tabDetail === DECCAN_MOBILE_TAB ? "SMS" : "Email"} to{" "}
              <span className="text-gray-700 font-bold">
                {tabDetail === DECCAN_MOBILE_TAB
                  ? `+91 ${userLoginDetail.phone || "-"}`
                  : `${userLoginDetail.email || "-"}`}
              </span>{" "}
              <span
                className="text-[#0087C1] cursor-pointer font-semibold"
                onClick={() =>
                  navigate(
                    `/auth?${REDIRECT_URL}=${reference}${
                      emailRequired !== "null"
                        ? `&emailRequired=${emailRequired}`
                        : ""
                    }${
                      signupMessage !== "null"
                        ? `&signupMessage=${signupMessage}`
                        : ""
                    }${
                      tabDetail === DECCAN_MOBILE_TAB
                        ? `&${SELECTED_TAB_SEARCH_QUERY_PARAM_NAME}=${mobile_tab_indetifier}`
                        : `&${SELECTED_TAB_SEARCH_QUERY_PARAM_NAME}=${email_tab_indetifier}`
                    }`
                  )
                }
              >
                Change
              </span>
            </p>
          )}

          <DeccanOtpForm
            tabDetail={tabDetail}
            reference={reference}
            OTP={OTP}
            setOTP={setOTP}
            otpError={otpError}
            setOtpError={setOtpError}
            isDisableVerifyBtn={isDisableVerifyBtn}
            setIsDisableVeifyBtn={setIsDisableVeifyBtn}
            isDisableResendBtn={isDisableResendBtn}
            setIsDisableResendBtn={setIsDisableResendBtn}
            handleOTPInput={handleOTPInput}
            resendOTP={resendOTP}
            progress={progress}
            pathname={pathname}
            setUserOTP={setUserOTP}
            userOTP={userOTP}
            userOtpError={userOtpError}
            setIsDisableUserVerifyBtn={setIsDisableUserVerifyBtn}
            isDisableUserVerifyBtn={isDisableUserVerifyBtn}
            isEmailUpdateOrPhoneNumber ={isEmailUpdateOrPhoneNumber}
            setUserOtpError={setUserOtpError}
          />
          <Footer
            footerLable={"Your Login, Simplified"}
            className="sm:mt-auto"
          />
        </div>
      </div>
    </div>
  );
}
